const USER_TYPES = {
  VIEWER: 'observer',
  EDITOR: 'contributor',
  OWNER: 'owner',
};

export default USER_TYPES;
